export default __webpack_public_path__ + "static/media/arrow-left-full.d3cd7edf.svg";